import styled from 'styled-components'
import { Button } from 'components/common'

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 343px;
  margin: 0 auto;
`

export const Image = styled.div`
  max-width: 240px;
  margin-bottom: 24px;
`

export const Title = styled.h2`
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: ${props => props.theme.primaryTextColor};
`

export const Subtitle = styled.p`
  color: ${props => props.theme.additionalTextColor};
  font-size: 16px;
  margin: 0 0 40px;
  text-align: center;
`

export const ButtonStyled = styled(Button)`
  width: 100%;
  justify-content: center;
`

export const ButtonsContainer = styled.div`
  position: fixed;
  width: 100%;
  padding: 20px 0px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 342px;
`